export const initFormData = {
  staffName:"",
  staffPhone:"",
  roleIdList:[] as any[],
  partnerIdList: [] as any[],
  dataStatus:"",
  slaveRelationUserList: [] as any[],
};
